import { alertBaseUrlMapper } from '@/plugins/eventTrackManager/const';

export const ALERT_MONITOR_ID = 'checkout-web-6906001';
export const ALERT_MONITOR_PATH = '/alert/api/v1/alert/monitor/trigger';
export const ALERT_MONITOR_TEST_CODE_HASH = 'ebdb922cb0ac244168d2dfdf28c3e24f72e9f4f7e065826df9cc9d06a5760627';
export const ALERT_MONITOR_METADATA = 'CHECKOUT-WEB code warning';

export function getAlertMonitorBaseUrl(nodeEnv = process.env.NODE_ENV) {
  return alertBaseUrlMapper[nodeEnv] || alertBaseUrlMapper.beta;
}

export function buildAlertThreadId({
  now = Date.now(),
  random = Math.random(),
} = {}) {
  const randomSuffix = Math.floor(random * 1e8).toString(36);

  return `checkout-web-${now}-${randomSuffix}`;
}

export function buildAlertMonitorPayload(errorMessage, options = {}) {
  return {
    applicationMonitorId: ALERT_MONITOR_ID,
    metadata: ALERT_MONITOR_METADATA,
    threadId: options.threadId || buildAlertThreadId(options),
    errorMessage: typeof errorMessage === 'string' ? errorMessage : JSON.stringify(errorMessage),
  };
}

function arrayBufferToHex(buffer) {
  return Array.from(new Uint8Array(buffer))
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('');
}

export async function hashAlertMonitorAccessCode(code, cryptoImpl = window.crypto) {
  if (!cryptoImpl || !cryptoImpl.subtle) {
    throw new Error('Current environment does not support crypto.subtle');
  }

  const content = new TextEncoder().encode(code);
  const buffer = await cryptoImpl.subtle.digest('SHA-256', content);

  return arrayBufferToHex(buffer);
}

export async function isAlertMonitorAccessCodeValid(code, cryptoImpl = window.crypto) {
  if (!code) {
    return false;
  }

  return (await hashAlertMonitorAccessCode(code, cryptoImpl)) === ALERT_MONITOR_TEST_CODE_HASH;
}

export function buildAlertMonitorTestExtraData({
  routePath = window.location.pathname + window.location.search,
} = {}) {
  return {
    e: 'code_error',
    lmo: `[alert-monitor-test] manual alert trigger: ${routePath}`,
  };
}
